import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollUp = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      type="button"
      onClick={scrollUp}
      aria-label="Back to top"
      data-testid="back-to-top-btn"
      className={`fixed bottom-6 right-6 z-50 h-12 w-12 flex items-center justify-center rounded-full
        bg-[#29abe2] text-white shadow-lg shadow-[#0f2438]/20
        hover:bg-[#0f2438] transition-all duration-300
        focus:outline-none focus:ring-2 focus:ring-[#29abe2] focus:ring-offset-2
        ${visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3 pointer-events-none"}`}
    >
      <ArrowUp size={20} strokeWidth={2.2} />
    </button>
  );
}
